// Boot-Blende aus dem EIGENEN Hintergrundbild (Jans Entscheidung 02.09.2026).
//
// #573 nahm als Boot-Blende das Vorschaubild (thumbnailResized) — auf Benedikts
// Test-Scrolly passte das zufällig zum Inhalt, bei WKs „Feierabendorte" war es
// ein Werbe-Teaser (Palmen), der im Scrolly nirgends vorkommt. Jans Regel:
// **Das Vorschaubild gehört in Feed-Kacheln und Link-Vorschauen, nicht auf den
// Titel.** Die Blende zeigt stattdessen das Hintergrundbild des Scrollys
// selbst — exakt das, was nach dem Ausblenden darunter erscheint. Gibt es
// keins, gibt es KEINE Blende (nur der Vorhang, Jans Regel vom 24.08.) —
// niemals den Teaser als Ersatz.
//
// Marker: Der Template-Editor setzt `isBackground: true` am Hintergrund-Layer
// (findBackgroundLayerIndex in app/src/utils/TemplateJsonUtils.ts — Bild ODER
// Video). Nutzbar für die Blende ist nur ein BILD (content.url); ein
// Video-Hintergrund liefert bewusst undefined.

export function extractBackgroundImageUrl(json: unknown): string | undefined {
  if (!json || typeof json !== "object") return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const j = json as any;
  // Shapes wie in first-image.ts / extractThumbnailUrl: PostBackend
  // (data.layers), PostJson-Wrapper (data.data.layers) oder rohes
  // Presentation-Objekt (layers).
  const layers: unknown[] = Array.isArray(j?.data?.data?.layers)
    ? j.data.data.layers
    : Array.isArray(j?.data?.layers)
      ? j.data.layers
      : Array.isArray(j?.layers)
        ? j.layers
        : [];
  for (const raw of layers) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layer = raw as any;
    if (!layer || layer.isBackground !== true) continue;
    if (layer.type !== "image") return undefined; // Video-Hintergrund: keine Blende
    const url =
      typeof layer.content?.url === "string" ? layer.content.url.trim() : "";
    return url || undefined;
  }
  return undefined;
}
